import styles from "./AgeRestrictionMessage.module.scss";

type Props = {
  minimumAge: number | null | undefined;
};

export const AgeRestrictionMessage = ({ minimumAge }: Props) => {
  if (!minimumAge) return null;

  return (
    <div data-testid="age:restriction" className={styles.ageRestrictionMessage}>
      <span className={styles.message}>
        We cannot sell this product to anyone under {minimumAge}
      </span>
    </div>
  );
};
